import { Link } from '@overdose/components'
import classNames from 'classnames'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import styles from './StoreListItem.module.css'
import { StoreListItemProps } from './StoreListItem.types'

const StoreListItem = ({ index, store }: StoreListItemProps) => {
  const storeName = store?.displayName || store?.name
  const isReseller = storeName.toLowerCase().includes('reseller')

  return (
    <div className='flex items-start gap-x-4'>
      <div
        className={classNames(
          'bg-interactive-action-primary text-action-primary w-8 h-8 rounded-full grid place-content-center',
          {
            [styles.resellerBackgroundColor]: isReseller,
          }
        )}>
        <Typography
          tag={TypographyTag.span}
          variant={TypographyVariant.BodyRegularBold}>
          {store.id || index}
        </Typography>
      </div>
      <div className='flex-1'>
        <div className='mb-1 text-primary-heading'>
          <Typography
            tag={TypographyTag.p}
            variant={TypographyVariant.BodyLargeBold}>
            {store?.name}
          </Typography>
        </div>
        <Typography
          tag={TypographyTag.p}
          variant={TypographyVariant.BodyRegularExtraLineHeight}>
          {store.address.streetNumber} {store.address.streetName},{' '}
          {store.address.city}, {store.address.state} {store.address.postalCode}
          , {store.address.country}
        </Typography>
        <Link to={store.url} title={store.name}>
          <Typography
            tag={TypographyTag.p}
            variant={TypographyVariant.BodyRegularBold}
            className='mt-3'>
            <span className='underline font-bold'>View Details</span>
          </Typography>
        </Link>
      </div>
    </div>
  )
}

export default StoreListItem
